import { render, staticRenderFns } from "./HighlightWorkspace.vue?vue&type=template&id=51bb14b4&scoped=true"
import script from "./HighlightWorkspace.vue?vue&type=script&lang=js"
export * from "./HighlightWorkspace.vue?vue&type=script&lang=js"
import style0 from "./HighlightWorkspace.vue?vue&type=style&index=0&id=51bb14b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bb14b4",
  null
  
)

export default component.exports